import {BaseContainerModel} from '../base-container.model';
import {bl_applet_setting_filter_fi_item_category_link_RowClass} from '../../dbschema';

export class AppletSettingFilterItemCategoryLinkContainerModel extends BaseContainerModel {
  bl_applet_setting_filter_fi_item_category_link: bl_applet_setting_filter_fi_item_category_link_RowClass = new bl_applet_setting_filter_fi_item_category_link_RowClass();
}
